import { SSRPermissionsErrorHandler } from '../src/SSRPermissionsErrorHandler.ts';

export const ssrPermissionsErrorHandler = new SSRPermissionsErrorHandler();
